<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{
                                !isUpdate
                                    ? $t("adicionar-empresa")
                                    : $t("empresa")
                            }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()"
                            >
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav
                            v-if="$route.query.tela === 'cliente-empresa' || $route.query.tela === 'produto-empresa'"
                            class="breadcrumb"
                            aria-label="breadcrumbs"
                        >
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t(this.$route.meta.content) }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="redirectToPage()">
                                        {{ $t("empresa") }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? `${$route.params.id} - ${
                                                      loadingName
                                                          ? $t(
                                                                "carregando"
                                                            )
                                                          : name
                                                  }`
                                                : $t("adicionar-empresa")
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <nav
                            v-if="$route.query.tela === 'cliente-empresa'"
                            class="breadcrumb"
                            aria-label="breadcrumbs"
                        >
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t(this.$route.meta.content) }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="redirectToPage()">
                                        {{ $t("cliente") }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? `${$route.params.id} - ${
                                                      loadingName
                                                          ? $t(
                                                                "carregando"
                                                            )
                                                          : name
                                                  }`
                                                : $t("adicionar-empresa")
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>

                        <nav
                            v-else-if="$route.query.tela"
                            class="breadcrumb"
                            aria-label="breadcrumbs"
                        >
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro-cadastros")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t("agro-niveltecnologico") }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="redirectToPage()">
                                        {{ $t("novo-nivel-tecnologico") }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? `${$route.params.id} - ${
                                                      loadingName
                                                          ? $t(
                                                                "carregando"
                                                            )
                                                          : name
                                                  }`
                                                : $t("nova-empresa")
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <nav v-else class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t($route.meta.contexto)
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: `${$route.meta.abrev}-empresa-list`,
                                            })
                                        "
                                        >{{ $t("empresas") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? `${$route.params.id} - ${
                                            loadingName ? $t( "carregando")
                                            : isNewToEdit ? $route.params.name : name
                                        }`
                                        : $t("nova-empresa")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $route.query.tela
                                    ? redirectToPage()
                                    : $router.push({ name: `${$route.meta.abrev}-empresa-list` })
                            "
                        >
                            {{ $t("voltar") }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-main" v-if="isUpdate">
                    <router-link
                        tag="li"
                        :to="{
                            name: `${$route.meta.abrev}-empresa-dados-cadastrais-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                            params: { id: $route.params.id },
                        }"
                    >
                        <a>{{ $t("dados-cadastrais") }}</a>
                    </router-link>
                    <router-link
                        tag="li"
                        v-if="
                            permissaoPoliticaComercial.read && isUpdate && 
                            (
                                $route.meta.abrev == 'ven' || 
                                $route.meta.abrev == 'agro'
                            )
                        "
                        :to="{
                            name: `${$route.meta.abrev}-empresa-politica-comercial-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                            params: { id: $route.params.id },
                            query: { 
                                dadoscadastrais: abaSelecionada, 
                                politicacomercial: $route.query.politicacomercial 
                                    ? $route.query.politicacomercial
                                    : null,
                            },
                        }"
                    >
                        <a>{{ $t("politica-comercial") }}</a>
                    </router-link>
                </ul>

                <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        :class="{ active: abaSelecionada == i }"
                        v-show="listaPermissoes[aba].read"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <Geral
                    ref="tabGeral"
                    v-if="
                        abasAbertas['geral'] &&
                        !newToEdit &&
                        listaPermissoes['geral'].read
                    "
                    v-show="abas[abaSelecionada] == 'geral'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                    @isNewToEdit="isNewToEdit = $event"
                />

                <Tributacao
                    ref="tabTributacao"
                    v-if="
                        abasAbertas['tributacao'] &&
                        listaPermissoes['tributacao'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'tributacao'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                />

                <Usuario
                    ref="tabUsuario"
                    v-if="
                        abasAbertas['usuario'] &&
                        listaPermissoes['usuario'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'usuario'"
                    :isUpdate="isUpdate"
                />

                <Produto
                    ref="tabProduto"
                    v-if="
                        abasAbertas['produto'] &&
                        listaPermissoes['produto'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'produto'"
                />

                <Parametrizacao
                    ref="tabParametrizacao"
                    v-if="
                        abasAbertas['parametrizacao'] &&
                        listaPermissoes['parametrizacao'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'parametrizacao'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                />

                <Cliente
                    ref="tabCliente"
                    v-if="
                        abasAbertas['cliente'] &&
                        listaPermissoes['cliente'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'cliente'"
                    :isUpdate="isUpdate"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

// Abas
import Geral from "@/components/vendas/empresa/abas/Geral";
import Tributacao from "@/components/vendas/empresa/abas/Tributacao";
import Usuario from "@/components/vendas/empresa/abas/Usuario";
import Cliente from "@/components/vendas/empresa/abas/Cliente";
import Produto from "@/components/vendas/empresa/abas/Produto";
import Parametrizacao from "@/components/vendas/empresa/abas/Parametrizacao.vue";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";

export default {
    beforeRouteLeave(to, from, next) {
        if (
            from.name == `${this.$route.meta.abrev}-empresa-dados-cadastrais-new` &&
            to.name == `${this.$route.meta.abrev}-empresa-dados-cadastrais-edit`
        ) {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        Geral,
        Tributacao,
        Usuario,
        Produto,
        Parametrizacao,
        Cliente,
    },
    data() {
        return {
            next: undefined,
            abaSelecionada: 0,
            abas: [],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoPoliticaComercial: false,
            listaPermissoes: {},
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            name: null,
            loadingName: false,
            isNewToEdit: false,
            serviceEmpresa: new EmpresaService(this.$http, this.$router),
        };
    },
    mounted() {
        // @85391 - Descontinuado uso da query abaSelecionada em telas que possuem aba e sub-abas
        // if (this.$route.query.abaSelecionada) {
        //     this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        // } else 
        if (this.$route.query.dadoscadastrais && this.$route.params.id) {
            this.changeTab(this.$route.query.dadoscadastrais < this.abas.length 
                ? this.$route.query.dadoscadastrais
                : 0
            );
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        if (this.$route.meta.abrev == 'ven') {
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                'vendas',
                'empresa',
                'ven-empresa-dados-cadastrais'
            );
        } else if (this.$route.meta.abrev == 'pro') {
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                'promotor',
                'empresa',
                'pro-empresa-dados-cadastrais'
            );
        } else if (this.$route.meta.abrev == 'des') {
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                'des',
                'empresa',
                'des-empresa-dados-cadastrais'
            );
        } else if (this.$route.meta.abrev == 'agro') {
            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                'agro',
                'empresa',
                'agro-empresa-dados-cadastrais'
            );
        }
        
        if (
            (!this.isUpdate && !this.permissaoDadosCadastrais.create) ||
            (this.isUpdate && !this.permissaoDadosCadastrais.read)
        ) {
            this.$router.push({ 
                name: "acesso-nao-permitido",
                params: { tela: "empresa" },
            });
            return;
        } 

        this.mapAbas();

        // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
        for (let [key, value] of Object.entries(this.abas)) {
            this.abasAbertas[value] = false;

            if (this.$route.meta.abrev == 'ven') {
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    'vendas', 
                    'empresa', 
                    `ven-empresa-dados-cadastrais-${value}`
                );
            } else if (this.$route.meta.abrev == 'des') {
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    'despesas', 
                    'empresa', 
                    `des-empresa-dados-cadastrais-${value}`
                );
            } else if (this.$route.meta.abrev == 'pro') {
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    'promotor', 
                    'empresa', 
                    `pro-empresa-dados-cadastrais-${value}`
                );
            } else if (this.$route.meta.abrev == 'agro') {
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    'agro', 
                    'empresa', 
                    `agro-empresa-dados-cadastrais-${value}`
                );
            }
        }
        if (this.$route.meta.abrev == 'ven') {
            this.permissaoPoliticaComercial = this.hasPermissionAccess(
                'vendas', 
                'empresa', 
                'ven-empresa-politica-comercial'
            );
        } else if (this.$route.meta.abrev == 'agro'){
            this.permissaoPoliticaComercial= this.hasPermissionAccess(
                'agro', 
                'empresa', 
                'agro-empresa-politica-comercial'
            );
        }

        if (this.isUpdate) this.loadName();

        // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iciciar visível
        for (let [key, value] of Object.entries(this.listaPermissoes)) {
            if (value.read) {
                this.abaSelecionada = this.abas.findIndex((e) => e == key);
                this.abasAbertas[key] = true;
                break;
            }
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.loadNameEmpresa()
                .then((res) => {
                    this.name = res.content.nome;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadingName = false;
                })
        },
        loadNameEmpresa() {
            if(this.$route.meta.abrev == 'ven') {
                return this.serviceEmpresa.loadNameVendas(this.$route.params.id);
            } else if(this.$route.meta.abrev == 'pro') {
                return this.serviceEmpresa.loadNamePromotor(this.$route.params.id);
            } else if(this.$route.meta.abrev == 'des') {
                return this.serviceEmpresa.loadNameDespesas(this.$route.params.id);
            } else {
                return this.serviceEmpresa.loadNameAgro(this.$route.params.id);
            } 
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == "cliente-empresa" || this.$route.query.tela == "produto-empresa") {
                tempTela = this.$route.query.tela == "cliente-empresa" 
                    ? `${this.$route.meta.abrev}-cliente-dados-cadastrais-edit`
                    : `${this.$route.meta.abrev}-produto-dados-cadastrais-edit`
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: this.$route.query["id"] },
                        query: { 
                            dadoscadastrais: this.$route.query.dadoscadastrais, 
                            politicacomercial: this.$route.query.politicacomercial, 
                            analisecomercial: this.$route.query.analisecomercial,  
                        },
                    });
                }, 1000);
            } else {
                if (this.$route.query.tela == "agro-niveltecnologico-new") {
                    tempTela = this.$route.query.tela;
                } else if (this.$route.query.tela == "agro-niveltecnologico-edit") {
                    tempTela = this.$route.query.tela;
                } else {
                    tempTela = `${this.$route.meta.abrev}-empresa-list`;
                }
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: this.$route.query["id"] },
                        query: { abaSelecionada: tempAba },
                    });
                }, 1000);
            }
        },
        mapAbas() {
            if(this.$route.meta.abrev == 'ven' || this.$route.meta.abrev == 'pro') {
                this.abas = [
                    "geral",
                    "tributacao",
                    "usuario",
                    "parametrizacao",
                    "produto",
                    "cliente",
                ]
            } else if (this.$route.meta.abrev == 'agro') {
                this.abas = [
                    "geral",
                    "tributacao",
                    "usuario",
                    "parametrizacao",
                    "cliente",
                ]
            } else {
                this.abas = [
                    "geral",
                    "usuario",
                ]
            }
        }
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav-tabs-main {
            margin-bottom: 10px;
        }
        .nav-tabs-children {
            margin-bottom: 20px;
            li > a {
                text-transform: capitalize;
            }
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }
    }
}
</style>
